import { FormInstance } from "antd/es/form";
import _ from "lodash";
import moment from "moment";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IUcusSureRaporu_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IUcusSureRaporu_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  AddMonths: Date;
  AddMonths_dummy: Date;
  MurettebatComboListe: any[];
  MurettebatComboListe_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  UcusSureRaporu: any[];
  UcusSureRaporu_dummy: any[];
  isComp385716Visible: "visible" | "hidden";
  isComp271593Visible: "visible" | "hidden";
  isComp141058Visible: "visible" | "hidden";
}

export class UcusSureRaporu_ScreenBase extends React.PureComponent<
  IUcusSureRaporu_ScreenProps,
  any
> {
  ucussureraporu_255972_value_kuikaSelectBoxRef: React.RefObject<any>;
  ucussureraporu_399769_value_kuikaTableRef: React.RefObject<any>;
  ucussureraporu_973121_value_kuikaDatetimeRef: React.RefObject<any>;
  ml = [
    {
      Id: "bd00ad4a-ed44-61e3-4813-27fcfc1bccc8",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9f0b40ca-a5d3-4b72-bc52-230e83587430",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "bbe11961-3821-4daf-9980-cf9fb396a68b",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 923160, PropertyName: "value", Value: "Uçuş Süresi Raporu" },
        { Id: 385716, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 46824, PropertyName: "value", Value: "Mürettebat" },
        { Id: 255972, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 848050, PropertyName: "value", Value: "Tarih Aralığı" },
        {
          Id: 191557,
          PropertyName: "startDatePlaceholder",
          Value: "Başlangıç",
        },
        { Id: 191557, PropertyName: "endDatePlaceholder", Value: "Bitiş" },
        {
          Id: 674255,
          PropertyName: "value",
          Value: "* Sadece onaylanmış uçuş kayıtları dikkate alınır",
        },
        { Id: 135352, PropertyName: "label", Value: "Listele" },
        {
          Id: 399769,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 691861, PropertyName: "title", Value: "Uçuş No" },
        { Id: 578519, PropertyName: "value", Value: "[datafield:ucusno]" },
        { Id: 751858, PropertyName: "placeholder", Value: "15" },
        { Id: 7559311, PropertyName: "title", Value: "Motor Çalıştırma" },
        {
          Id: 3046555,
          PropertyName: "value",
          Value: "[datafield:motorcalistirma]",
        },
        { Id: 242438, PropertyName: "title", Value: "Motor Susturma" },
        {
          Id: 873914,
          PropertyName: "value",
          Value: "[datafield:motorsusturma]",
        },
        {
          Id: 973121,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 9350491, PropertyName: "title", Value: "Kalkış Nokta" },
        {
          Id: 7317383,
          PropertyName: "value",
          Value: "[datafield:kalkisnoktaaciklama]",
        },
        { Id: 5492710, PropertyName: "title", Value: "Varış Nokta" },
        {
          Id: 9067523,
          PropertyName: "value",
          Value: "[datafield:varisnoktaaciklama]",
        },
        { Id: 654924, PropertyName: "title", Value: "Mürettebat" },
        { Id: 647792, PropertyName: "value", Value: "[datafield:kisi]" },
        { Id: 309668, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 156710, PropertyName: "title", Value: "Süre (dk)" },
        { Id: 819375, PropertyName: "value", Value: "[datafield:suredk]" },
        { Id: 747100, PropertyName: "placeholder", Value: "15" },
        { Id: 776567, PropertyName: "title", Value: "Sorumlu Pilot?" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.ucussureraporu_385716_value_kuikaTextInputRef = React.createRef();
    this.ucussureraporu_255972_value_kuikaSelectBoxRef = React.createRef();
    this.ucussureraporu_399769_value_kuikaTableRef = React.createRef();
    this.ucussureraporu_973121_value_kuikaDatetimeRef = React.createRef();
    this.ucussureraporu_309668_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      AddMonths: "",
      MurettebatComboListe: [],
      SetValueOf: "",
      TriggerEvent: "",
      UcusSureRaporu: [],
      dataSource_792252: [
        { key: "1", text: "Mürettebat" },
        { key: "0", text: "Sorumlu Pilot" },
        { key: "2", text: "Hepsi" },
      ],
      isComp385716Visible: "hidden",
      isComp271593Visible: "hidden",
      isComp141058Visible: "hidden",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("ucussureraporu", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.UcusSureRaporuPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("ucussureraporu", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = [
      "FLYPILOT",
      "FLYTEKNISYEN",
      "FLYADMIN",
    ];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("ucussureraporu", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.UcusSureRaporuPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  UcusSureRaporuPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      date_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      months_0: ReactSystemFunctions.convertToTypeByName(-3, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusSureRaporu/UcusSureRaporuPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.AddMonths = result?.data.addMonths;
    stateVars.MurettebatComboListe = result?.data.murettebatComboListe;

    formVars.ucussureraporu_255972_options = stateVars.MurettebatComboListe;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusSureRaporuPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusSureRaporuPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "ucussureraporu_191557_value",
        "string"
      ),
      ReactSystemFunctions.value(this, this.state.AddMonths),
      ReactSystemFunctions.convertToTypeByName("startValue", "string"),
      false
    );
    if (await this.UcusSureRaporuComponent_135352_onClick()) return true;

    stateVars.dataSource_255972 =
      stateVars.MurettebatComboListe ?? this.state.MurettebatComboListe;
    stateVars.dataSource_255972 =
      stateVars.MurettebatComboListe ?? this.state.MurettebatComboListe;
    stateVars.isComp271593Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "ucussureraporu_399769_value",
          "isSorumluPilot"
        ),
        "1"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp141058Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "ucussureraporu_399769_value",
          "isSorumluPilot"
        ),
        "0"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  UcusSureRaporuComponent_981633_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "UcusSureRaporu",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "139195",
      null,
      "left",
      "true",
      "450px",
      "",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UcusSureRaporuComponent_135352_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BaslangicTarih_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucussureraporu_191557_value",
            "startValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarih_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "ucussureraporu_191557_value",
            "endValue",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      Kisi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "ucussureraporu_255972_value",
            "value",
            "MurettebatComboListe",
            "filtre",
            "filtre"
          )
        ),
        "string"
      ),
      IsSorumluPilot_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "ucussureraporu_792252_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UcusSureRaporu/UcusSureRaporuComponent_135352_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UcusSureRaporu = result?.data.ucusSureRaporu;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UcusSureRaporuComponent_135352_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UcusSureRaporuComponent_135352_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_399769 =
      stateVars.UcusSureRaporu ?? this.state.UcusSureRaporu;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.UcusSureRaporuPageInit();
    }
  }
}
